import React from 'react';

type CheckboxProps = {
  className?: string;
  label: string;
  value: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function Checkbox(props: CheckboxProps) {
  const { label, value, onChange, disabled, className } = props;
  return (
    <label className={className}>
      <input type="checkbox" checked={value} onChange={onChange} disabled={disabled} />
      <span className="checkmark" />
      <span>{label}</span>
      <style jsx>{`
        label {
          @apply select-none flex items-center text-black font-inter text-[14px] leading-[16.94px] relative pl-[42px] min-h-[24px] py-1;
        }

        input {
          @apply absolute opacity-0 cursor-pointer h-0 w-0;
        }

        .checkmark {
          @apply absolute top-1/2 left-0 h-[24px] w-[24px] rounded-[5px] border border-gray-300;
          transform: translateY(-50%);
        }

        label:hover input ~ .checkmark {
          @apply bg-gray-100;
        }

        label input:checked ~ .checkmark {
          @apply bg-black border-black;
        }

        .checkmark:after {
          content: "";
          @apply absolute hidden;
        }

        label input:checked ~ .checkmark:after {
          @apply block;
        }

        .checkmark:after {
          @apply left-[9px] top-[5px] w-[5px] h-[10px] border-solid border-white;
          border-width: 0 1.78px 1.78px 0;
          transform: rotate(45deg);
        }
      `}</style>
    </label>
  );
}

Checkbox.defaultProps = {
  onChange: () => {},
  disabled: false,
}

export default Checkbox
